import React from "react";
import "./AppDownload.css";
import Image from "@/components/AppImage/AppImage";
import appStoreBadge from "../../assets/app-store.svg";

const AppDownload: React.FC = () => {
  return (
    <div className="badge-container">
      <a
        href="https://apps.apple.com/ua/app/globe-thrivers/id6467179371?l=ru"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image src={appStoreBadge} alt="App Store" width={120} height={40} />
      </a>
    </div>
  );
};

export default AppDownload;
